import { IoMale, IoFemale } from 'react-icons/io5';
import { Strings } from '@/constants/strings';

export type GenderValue = 'male' | 'female';

interface GenderSelectionProps {
  value: GenderValue | null;
  onValueChange: (value: GenderValue) => void;
  error?: string;
}

const BUTTON_BASE =
  'flex flex-1 items-center justify-center gap-2 rounded-lg border-2 py-3 text-base font-bold transition min-h-[48px]';

export function GenderSelection({ value, onValueChange, error }: GenderSelectionProps) {
  return (
    <div>
      <p className="mb-2 text-[15px] font-medium text-text-heading">{Strings.gender}</p>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => onValueChange('male')}
          className={`${BUTTON_BASE} ${
            value === 'male'
              ? 'border-gender-male bg-gender-male text-white'
              : 'border-slate-200 bg-card-bg text-text-heading'
          }`}
          aria-pressed={value === 'male'}
          aria-label={Strings.male}
        >
          <IoMale
            className={`h-6 w-6 shrink-0 ${value === 'male' ? 'text-white' : 'text-gender-male'}`}
            aria-hidden
          />
          <span>{Strings.male}</span>
        </button>
        <button
          type="button"
          onClick={() => onValueChange('female')}
          className={`${BUTTON_BASE} ${
            value === 'female'
              ? 'border-gender-female bg-gender-female text-white'
              : 'border-slate-200 bg-card-bg text-text-heading'
          }`}
          aria-pressed={value === 'female'}
          aria-label={Strings.female}
        >
          <IoFemale
            className={`h-6 w-6 shrink-0 ${value === 'female' ? 'text-white' : 'text-gender-female'}`}
            aria-hidden
          />
          <span>{Strings.female}</span>
        </button>
      </div>
      {error && (
        <p className="mt-1 text-xs text-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
